export const styleCM = {
    cm_text: {
        fontSize: '16px',
        fontFamily: 'Zen Kaku Gothic New',
        lineHeight: '1.6',
        fontWeight: 700,
        color: '#2E3138'
    },
    d_flex: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '16px'
    },
    d_flex_space_between: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px'
    },
    d_flex_column: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'left',
    }
};

export const elStyle = {
    fw500: {
        ...styleCM.cm_text,
        fontWeight: 500
    },
    fz12_green: {
        ...styleCM.cm_text,
        fontSize: '12px',
        color: '#1DA578'
    },
    fz14: {
        ...styleCM.cm_text,
        fontSize: '14px',
        fontWeight: 500
    },
    fz14_grey: {
        ...styleCM.cm_text,
        fontSize: '14px',
        color: '#9096A2',
        fontWeight: 500
    },
    total_price_label: {
        ...styleCM.cm_text,
        p: '16px'
    },
    payment_price: {
        ...styleCM.d_flex,
        justifyContent: 'space-between',
        borderBottom: '1px #E3E5E8 solid',
        bgcolor: '#F8F2E4'
    },
    label_discount: {
        ...styleCM.d_flex,
        padding: '16px',
        justifyContent: 'space-between',
        borderBottom: '1px #E3E5E8 solid',
        // bgcolor: '#F8F2E4'
    },
    total_value: {
        ...styleCM.d_flex,
        justifyContent: 'space-between',
        borderBottom: '1px #E3E5E8 solid',
        // bgcolor: '#F8F2E4'
    },
    warning_icon: {
        pl: '15px',
        ...styleCM.d_flex,
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        flexWrap: 'nowrap'
    },
    warning_content: {
        pl: '10px',
        ...styleCM.cm_text,
        fontSize: '15px',
        fontWeight: 500,
        color: '#9096A2',
        whiteSpace: 'normal'
    },
    contract_confirm_label: {
        ...styleCM.cm_text,
        fontSize: '14px',
        fontWeight: 700,
        bgcolor: '#F2F3F5',
        p: 1,
        style: {
            borderTop: '1.75px solid rgb(227, 229, 232)',
            borderBottom: '1.75px solid rgb(227, 229, 232)'
        }
    },
    dialog_policy_title: {
        ...styleCM.cm_text,
        fontSize: '22px',
        lineHeight: '2.4'
    },
    dialog_policy_cotent_wrapper: {
        maxHeight: '480px',
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center'
    },
    dialog_policy_cotent: {
        maxWidth: '98%',
        p: '24px 36px 0px 36px',
        bgcolor: '#ECF2FB',
        border: '1px solid #E3E5E8'
    }
};

export const dropdownStyle = {
    dropdown_select_container: {
        ...styleCM.d_flex_space_between,
        paddingLeft: '16px',
        paddingRight: '16px',
    },
    dropdown_select_label: {
        ...elStyle.fw500,
        flex: '0.3',
    },
    dropdown_select_input: {
        // padding : '16px'
    }
}
